"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeGetPromoBasketPopupState = void 0;
const reselect_1 = require("reselect");
const promoBasketPopupStateSelector = state => state.promoBasketPopup;
const makeGetPromoBasketPopupState = () => (0, reselect_1.createSelector)(promoBasketPopupStateSelector, (promoBasketPopupState) => promoBasketPopupState);
exports.makeGetPromoBasketPopupState = makeGetPromoBasketPopupState;
